import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Shared section intro so every section speaks with one voice:
// uppercase eyebrow → serif heading → supporting line. Keeps headers visually
// identical across the page instead of each section inventing its own.
const SectionHeader = ({ eyebrow, title, subtitle, align = 'center', style }) => {

    const centered = align === 'center';

    return (
        <div style={{
            textAlign: align,
            maxWidth: (subtitle && centered) ? 725 : undefined,
            margin: centered ? '0 auto' : 0,
            marginBottom: Utils.isMobile() ? 36 : 48,
            ...style,
        }}>
            {eyebrow && (
                <span style={{ ...Appearance.textStyles.label(), display: 'block', marginBottom: 14 }}>
                    {eyebrow}
                </span>
            )}
            <h2 style={{
                ...Appearance.textStyles.sectionHeading({ textAlign: align }),
                marginBottom: subtitle ? 16 : 0,
                textWrap: 'balance', // no single word stranded on the last line
            }}>
                {title}
            </h2>
            {subtitle && (
                <p style={{
                    ...Appearance.textStyles.sectionSubheading({ textAlign: align }),
                    margin: centered ? '0 auto' : 0,
                }}>
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default SectionHeader;
